import React, { useState } from 'react';
import { AppOptionType, OptionType } from '../../../features/manageHomepage/ManageHomePageTypes';
import { getFlatenedConfigListMapWithUniqueDomainValues, getMergedConfigMap, saveStudioConfig } from '../../../services/uiConfigService';
import NewConfigComparePopup from '../../../features/salescodeStudio/mandatoryConfigs/optionalFeatures/widget/NewConfigComparePopUp';
import { RolesSelectionPopup } from './RolesSelectionPopup';

interface Props {
  inputData: {
    requiredConfigsMap: Record<string,any>;
    initialConfigMap: Record<string,any>; // change it to a map . 
    updatedConfigMap: Record<string,any>;
    appType: AppOptionType;
    role: OptionType;
    affectAppTypeSpecificConfig?: boolean ;
    featureSelectionFlag?: boolean;
  };
  onCancel: () => void;
  actionPostSuccess?: () => void;
}
export const StudioRoleSelectionAndSavePopupModal: React.FC<Props> = ({
  inputData,
  onCancel,
  actionPostSuccess
}) => {
const [selectedRoles, setSelectedRoles] = useState<OptionType[]>([inputData.role]);
const [showConfigPopup, setShowConfigPopup] = useState(true); // initially true
const [showClonePopup, setShowClonePopup] = useState(false); // only shown after first success

const mergedUpdatedConfigMap: Record<string, any> = getMergedConfigMap(inputData.updatedConfigMap,inputData.initialConfigMap);
const curConfigMap: any = getFlatenedConfigListMapWithUniqueDomainValues(inputData.initialConfigMap); 
const newConfigMap: any = getFlatenedConfigListMapWithUniqueDomainValues(mergedUpdatedConfigMap); 
const onConfigComparatorSuccess = async () => {
  setShowConfigPopup(false);
  setShowClonePopup(true);
};
const onSave = async () => {
  saveStudioConfig(inputData.role,inputData.appType,selectedRoles,inputData.requiredConfigsMap,inputData.initialConfigMap,inputData.updatedConfigMap,inputData.affectAppTypeSpecificConfig,inputData.featureSelectionFlag,()=>{
    onCancel();
    actionPostSuccess?.();
  });
}
return (
  <>
    {showConfigPopup && (
      <NewConfigComparePopup
        message="Are you sure want to update the config"
        showConfigPopup={showConfigPopup}
        setShowConfigPopup={setShowConfigPopup}
        curConfig={curConfigMap}
        newConfig={newConfigMap}
        onSuccess={onConfigComparatorSuccess}
        onCancel={onCancel}
      />
    )}

    {showClonePopup && (
      <RolesSelectionPopup
        appType={inputData.appType}
        selectedRoles={selectedRoles}
        setSelectedRoles={setSelectedRoles}
        onSave={onSave}
        onCancel={onCancel}
      />
    )}
  </>
);

};
